<app-chat-wrapper *ngIf="!loading"
                  [mediaType]="mediaType"
                  [mediaId]="mediaId"
                  [mode]="PLAYER_MODE.VIEWER"
></app-chat-wrapper>
